import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'tvlCurrency', pure: true })
export class TvlCurrencyPipe extends CurrencyPipe implements PipeTransform {
  transform(
    value: any,
    currencyCode?: string,
    display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    digitsInfo?: string,
    locale?: string
  ): any {
    return super.transform(
      value,
      currencyCode,
      display,
      digitsInfo ?? value % 1 == 0 ? '1.0-0' : '0.2-2',
      locale
    );
  }
}
